import React , {useEffect, useState} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";


// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

import { Link, Redirect } from "react-router-dom";

import axios from 'axios'

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

export default function NewUser() {


    const [description, setdescription] = React.useState("");
    const [descriptionState, setdescriptionState] = React.useState("");
    const [redirctTo, setRedirctTo] = useState(false);
    const [redirctTo_new_user, setRedirctTo_new_user] = useState(false);
    const [token_logged, settoken_logged] = React.useState("");
    const [tc, setTC] = React.useState(false);
    const [Errmessage, setErrmessage] = React.useState("");

    

    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };

    

  
  React.useEffect(() => {

      document.getElementById("test_id").innerHTML = "New Code Set";

      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     
          console.log( res2.data );

        }
        getToken()
          } catch (err) {
            setRedirctTo(true);
        }
      }else{
        setRedirctTo(true)
      }
    
  }, [  ]);
  

  const registerClick = async e => {
    let valid = 1;
    e.preventDefault();

    if (description === "") {
        setdescriptionState("error");
        valid = 0;
    }

    if(description.length < 6){
        setdescriptionState("error");
        valid = 0;
        setErrmessage("Code Set 6 Characters Required");
        showNotification(true);
    }
    if(valid === 1){
        try {
            const res = await axios.post('/codeset/register', {
                description
            })
            console.log(res.data.msg);

            setRedirctTo_new_user(true);
            //setUser({...user, err: '', success: res.data.msg})
        } catch (err) {
            setErrmessage(err.response.data.msg);
            showNotification(true);
            //err.response.data.msg && 
            //setUser({...user, err: err.response.data.msg, success: ''})
        }     
    }
    



  };

  const classes = useStyles();

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  if (redirctTo_new_user){
    return <Redirect to='/admin/code_sets'  />
  }


  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };
  
  
  return (
    <div>

      <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
      
      <GridContainer>
          
        <GridItem xs={12} sm={12} md={12}>
            <div className={classes.right}>
                <Link to="/admin/code_sets">
                  <Button color="rose" className={classes.right}>
                      Back to All Codesets
                  </Button>
                </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save Code Set
                </Button>
            </div>
          <Card>
            <CardBody>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={descriptionState === "success"}
                            error={descriptionState === "error"}
                            labelText="Code Set"
                            id="name"
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    if (verifyLength(event.target.value, 1)) {
                                        setdescriptionState("success");
                                    } else {
                                        setdescriptionState("error");
                                    }
                                    setdescription(event.target.value);
                                },
                            type: "text",
                            autoComplete: "off"
                            }}
                        />
                    </GridItem>
                </GridContainer>
            
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
